import { ApiService } from "./api.service";

export default class TBEService extends ApiService {
  namespace = "toBeEntered";
  DOMAIN = -63;
  name = "Payable Credit";
  template = "defaultTemplate";
  Width = 1100;
  icon = "Check";
  favicon = "Check";
  showLeftBar = false;
  singular = this.terminology.tbe.singular;
  plural = this.terminology.tbe.plural;
  vowel = this.terminology.tbe.vowel;

  constructor() {
    super("ap-bills");
  }
}
